import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Header } from '../../components/layout/Header'
import { Card } from '../../components/common/Card'
import { useTheme } from '../../contexts/ThemeContext'

export const ConsumerRightsPage: React.FC = () => {
  const { colors } = useTheme()
  const navigate = useNavigate()

  const consumerRights = [
    {
      right: 'Right of Withdrawal',
      duration: '14 days',
      description: 'Consumers can return products within 14 days of delivery without giving any reason',
      details: [
        'Starts from day of delivery (not purchase)',
        'Seller must refund within 14 days of receiving return',
        'Seller can withhold refund until goods received',
        'Consumer pays return shipping unless seller agrees otherwise',
      ],
    },
    {
      right: 'Legal Guarantee',
      duration: '2 years',
      description: 'Products must conform to contract for 2 years from delivery',
      details: [
        'Defects appearing within 1 year presumed to exist at delivery',
        'Seller must repair, replace, or refund faulty goods',
        'Consumer can choose remedy (repair or replacement)',
        'Some countries extend to 3 years (Sweden) or 6 years (Ireland)',
      ],
    },
    {
      right: 'Pre-contractual Information',
      duration: 'Before purchase',
      description: 'Detailed information must be provided before purchase',
      details: [
        'Total price including all taxes',
        'Delivery costs and arrangements',
        'Right of withdrawal information',
        'Identity and contact details of seller',
        'Complaints handling procedure',
      ],
    },
  ]

  const countryVariations = [
    { country: 'Germany', notes: 'Widerrufsrecht strictly enforced | Abmahnung (cease & desist) common for non-compliance' },
    { country: 'France', notes: '14-day withdrawal | Additional 7-day grace period for refund' },
    { country: 'Netherlands', notes: 'Consumer Authority (ACM) active enforcement | Cooling-off period awareness high' },
    { country: 'Spain', notes: '14-day withdrawal | Consumer Arbitration system popular' },
    { country: 'Italy', notes: 'Codice del Consumo | Strong consumer protection culture' },
  ]

  return (
    <div style={{ minHeight: '100vh', backgroundColor: colors.background }}>
      <Header />
      <main style={{ maxWidth: '1440px', margin: '0 auto', padding: '40px 32px' }}>
        <div style={{ marginBottom: '32px' }}>
          <button
            onClick={() => navigate('/compliance')}
            style={{
              background: 'none',
              border: 'none',
              color: colors.primary,
              cursor: 'pointer',
              marginBottom: '16px',
              fontSize: '14px',
            }}
          >
            &larr; Back to Compliance Center
          </button>
          <h1 style={{ fontSize: '32px', marginBottom: '8px', color: colors.textPrimary }}>
            Consumer Rights & Returns
          </h1>
          <p style={{ color: colors.textSecondary, fontSize: '16px' }}>
            Return policies, warranty requirements, and consumer protection obligations
          </p>
        </div>

        {/* Key Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginBottom: '32px' }}>
          <Card style={{ textAlign: 'center', borderTop: '4px solid #F59E0B' }}>
            <div style={{ fontSize: '36px', fontWeight: 700, color: '#F59E0B' }}>14</div>
            <div style={{ fontSize: '14px', color: colors.textSecondary }}>Days Withdrawal Right</div>
          </Card>
          <Card style={{ textAlign: 'center', borderTop: '4px solid #50C878' }}>
            <div style={{ fontSize: '36px', fontWeight: 700, color: '#50C878' }}>2</div>
            <div style={{ fontSize: '14px', color: colors.textSecondary }}>Years Legal Guarantee</div>
          </Card>
          <Card style={{ textAlign: 'center', borderTop: '4px solid colors.primary' }}>
            <div style={{ fontSize: '36px', fontWeight: 700, color: colors.primary }}>14</div>
            <div style={{ fontSize: '14px', color: colors.textSecondary }}>Days to Refund</div>
          </Card>
        </div>

        {/* Consumer Rights Details */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', marginBottom: '32px' }}>
          {consumerRights.map((item) => (
            <Card key={item.right}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                <div>
                  <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '4px', color: colors.textPrimary }}>
                    {item.right}
                  </h3>
                  <p style={{ fontSize: '14px', color: colors.textSecondary }}>{item.description}</p>
                </div>
                <span style={{
                  padding: '6px 14px',
                  backgroundColor: '#F59E0B15',
                  borderRadius: '16px',
                  fontSize: '14px',
                  fontWeight: 600,
                  color: '#F59E0B',
                }}>
                  {item.duration}
                </span>
              </div>
              <ul style={{ margin: 0, paddingLeft: '16px', color: colors.textSecondary, fontSize: '14px', lineHeight: 1.8 }}>
                {item.details.map((detail, idx) => (
                  <li key={idx}>{detail}</li>
                ))}
              </ul>
            </Card>
          ))}
        </div>

        {/* Country Variations */}
        <Card>
          <h2 style={{ fontSize: '20px', marginBottom: '20px', color: colors.textPrimary }}>
            Country-Specific Consumer Protection
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {countryVariations.map((item) => (
              <div
                key={item.country}
                style={{
                  padding: '16px',
                  border: `1px solid ${colors.border}`,
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                }}
              >
                <span style={{ fontWeight: 600, minWidth: '100px', color: colors.textPrimary }}>{item.country}</span>
                <span style={{ fontSize: '14px', color: colors.textSecondary }}>{item.notes}</span>
              </div>
            ))}
          </div>
        </Card>
      </main>
    </div>
  )
}
